// extracted by mini-css-extract-plugin
export default {"priorityMediumIcon":"styles__priorityMediumIcon__c1913afed72ac628ac8d"};